import { api } from "api";

export const getSurveys = (onBegin, onSuccess, onError) => {
  return async (dispatch) => {
    onBegin();
    await api
      .get("/api/survey/get-surveys")
      .then((res) => {
        dispatch({
          type: "GET_SURVEY_SUCCESS",
          payload: res.data.data,
        });

        onSuccess(res);
      })
      .catch((e) => {
        dispatch({
          type: "GET_SURVEY_ERROR",
          payload: e,
        });
        onError(e);
      });
  };
};
